
<div>
    <div (mouseleave)="showDropDown = false">
        <button class="drop-toggle btn flat py-2" (click)="showDropDown=!showDropDown">
            <span *ngIf="checkedList.length<=0">Select</span>
            <span *ngIf="checkedList.length>0">{{friendlyNames.join(', ')}}</span>
            <i class="fa fa-angle-down"></i>
        </button>
        <div class="drop-show" *ngIf="showDropDown">
            <label *ngFor="let a of list;let i = index;">
                <input type="checkbox" [(ngModel)]="boolsList[i]"
                    (change)="getSelectedValue(boolsList[i],a.id,a.friendlyName)" 
                    class="me-2 my-1"/>
                <span class="my-1">{{a.friendlyName}}</span>
            </label>
        </div>
    </div>
</div>